exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#sidebar .subheading .ant-menu-item-group-title {\n  font-weight: 700;\n  padding-left: 14px;\n  font-size: 0.8rem;\n}\n#sidebar .ant-menu-item-group-title {\n  padding-left: 24px;\n}\n#sidebar .ant-menu-item-group-list .ant-menu-item {\n  padding-left: 34px!important;\n}\n", ""]);

